import { Box } from '@mui/material'
import { Hint } from 'components/Hint'
import React, { FC } from 'react'
import {
  hasDigit,
  hasLowercaseCharacter,
  hasUppercaseCharacter,
} from 'utils/string'

import { HintsBlockProps } from './HintsBlock.types'

export const HintsBlock: FC<HintsBlockProps> = ({ password }) => {
  return (
    <Box
      flexWrap='wrap'
      justifyContent='space-between'
      display='flex'
      flexDirection='row'
      sx={{
        mb: '24px',
        flexDirection: {
          sm: 'column',
          md: 'column',
          lg: 'row',
          xl: 'row',
        },
      }}
    >
      <Hint isChecked={password.length >= 12}>12 characters min</Hint>
      <Hint isChecked={hasLowercaseCharacter(password)}>
        Lowercase character
      </Hint>
      <Hint isChecked={hasUppercaseCharacter(password)}>
        Uppercase character
      </Hint>
      <Hint isChecked={hasDigit(password)}>Number</Hint>
    </Box>
  )
}
